_updatePortal